import { useTranslation } from 'react-i18next'
import React from 'react'
import { pathOr } from 'ramda'
import { convertData } from '@shared/innmaxLib/services'
import { momentToString } from '@shared/utils/webHelper'
import { useAllSessions } from '../session'
import moment from 'moment'

export const useConvertChargingPayment = (res: any) => {
  const { byId } = useAllSessions()
  const { t } = useTranslation()

  const dataSource = React.useMemo(
    () =>
      convertData<any>({
        converter: x => {
          let seconds: number = x.transTime / 1000
          const hours = seconds / 3600
          const minutes = seconds / 60

          return {
            ...x,
            deviceTypeStr: x.deviceType && t(`device:${x.deviceType}`),
            createAtStr: momentToString(x.createAt, 'YYYY/MM/DD HH:mm:ss'),
            transStartAtStr: momentToString(
              x.transStartAt,
              'YYYY/MM/DD HH:mm:ss'
            ),
            sessionName: pathOr(
              t('report:no area assigned'),
              [x.sessionId, 'name'],
              byId
            ),
            // transTimeStr: (
            //   Math.round((x.transTime / (1000 * 60)) * 100) / 100
            // ).toString(),
            transTimeStr: msToTime(x.transTime),
            // transTimeStr:moment(x.transTime).format('HH:mm'),
            // transTimeStr:momentToString(x.transTime, 'HH:mm'),
          }
        },
      })(res),
    [res]
  )

  return { dataSource }
}

function msToTime(duration: number): string {
  const seconds = Math.floor((duration / 1000) % 60);
  const minutes = Math.floor((duration / (1000 * 60)) % 60);
  const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  const hh = (hours < 10) ? '0' + hours : hours;
  const mm = (minutes < 10) ? '0' + minutes : minutes;

  return hh + ":" + mm;
}
